var Backbone = require('backbone'),
    Util = require('../../FV/util'),
    _ = require('underscore');

/*
* Store for settings and validation of user parameters.
* Not a Server Model
* */

module.exports = Backbone.Model.extend({

    validImgFileTypes: ['JPG', 'JPEG', 'GIF', 'PNG', 'BMP'], /* note: those that can be rendered in the browser; also used to derived if page is 'imageType' */

    /* those presented to the user */
    docModeScaleValues: { /* label, scale value */
        Auto: 'Auto',
        'Fit Width': 'Fit Width',
        'Fit Height': 'Fit Height'
    },
    pageModeScaleValues: { /* label, scale value */
        'Best Fit': 'Best Fit',
        'Fit Width': 'Fit Width',
        'Fit Height': 'Fit Height',
        '50%': 0.50,
        '75%': 0.75,
        '100%': 1.00,
        '125%': 1.25,
        '150%': 1.50,
        '200%': 2.00,
        'Dot For Dot': 1.00
    },

    maxDocWidth: 1000, /* note: only applicable to document */

    zoomIncrement: 0.10, /* for zoom in / zoom out -- for now, not able to be over written -- not an attr */
    minScale: 0.25, //note: now only applicable to zoom in / zoom out
    MIN_IMG_SCALE: 0.02, //(not work the user can set, but the smallest a resize can set the image to) -- TODO: combo with minScale ...(zoom increment)?

    viewModes: ['document', 'page', 'pdf'], //array possible modes
    minimumWidth: '300px', //(for layout resize purposes)

    MAX_NUM_IMAGES_TO_LOAD: 3,
    IMAGE_LD_FAIL_CHECK_TIME: 5000, // note: currently unused

    /*
    * See: http://git.feith.com/projects/ENG-CRE/repos/central-rendering-engine/browse/central-rendering-engine-service/src/main/resources/META-INF/cre-file-extensions.xml
    * Note: accessed from the prototype, not vChannel
    * */
    renderableFileExts: [ 'PDF', 'JPG', 'JPEG', 'GIF', 'TIF', 'TIFF', 'PNG', 'BMP',
        'DOC', 'DOCX', 'XLS', 'XLSX', 'XLSB', 'XLSM', 'PPT', 'PPTX', 'PPTM',
        'TXT', 'RTF', 'EML', 'XPS', 'MSG', 'MPP', 'VSD', 'HTML', 'HTM', 'XHTML' ],

    // TODO: facades for the prototype 'default' settings

    defaults: {

        el: null, /* the element holding the viewer -- NOTE: necessary for setting the derived height of pages, if not provided it's set to 'body' */
        fullScreen: false, /* true if no el provided, (also case when opened popup -- TODO: logical separate w/ attr in viewer model ( note: this now stored on there */

        viewMode: 'document', //the mode to start the viewer in (if none provided, defaultViewMode of globalSettings)
        imageFileType: 'jpg',

        docModeScale: 'Auto',
        pageModeScale: 'Fit Width', /* Note: this is the default overall but is dependant on the page type (if isImageType -- best fit) */

        /* eventHooks */
        onLoad: null,

        fromReset: false, //TODO: rid?

        hideIndexes: false,
        autoDisplayIndexes: true,
        forceOpenToNotes: null,

        excludePageNotes: false,
        hideActivityNotes: true,

        fullTextQuery: null,
        fullTextQuickView: false,
        createNewRedactionOnEntry: false,

        disableDocMode: false,
        pdfOnly: false,
        singlePageOnly: false,
        disableThumbs: false, //don't include thumbnails

        openToPageNumber: 1,

        findAndRedact: null,

        singularViewMode: false //TODO: not yet used but use to replace pdf only
    },

    /**
     * Options are user provided -- note -- they are required (only called from viewer)
     * These should really be referred to as attributes as this is a Backbone model
     * ( and are already set in the contructor )
     */
    initialize: function(options) {




        /**
         * Store a copy of the original, 'non overwritten' options.
         * Will come into play with updatePostUserFetch ( DVBC-1718 - update, this is no longer used )
         * DVBC-1718 - no longer user but leave in place in case necessary in the future,
         * where implemented for DVBC-1711
         */
        this.originalOptions = _.clone(options);

        var o = options;

        /**
         * Setting Dependent -- Can Be Over-Written
         * Over-Writing Defaults if logic not directly based on the option property,
         * also set other settings based on the params
         */
        this.set( _.extend( o, {
            fullScreen: !o.el || o.el.nodeName === "BODY" /* latter necessary because el set prior to this init call */
        }));

        /**
         * Silent validations: when invalid, set it to the defaults, allowing viewer to load without failure
         * Do more organization when tackle DVBC-1246 ... eg this is verbose -- could do in first extend, etc
         *  Another check done prior to docInfo fetch to see if the number exists.
         */

        this.set({ openToPageNumber: this.getValidatedOpenToPageNumber( o.openToPageNumber ) });

        /* Overriders */

        o.pdfOnly && this.set({
            viewMode: 'pdf',
            excludePageNotes: true,
            pdfOnly: true,
            disableThumbs: true
        });

        o.singlePageOnly && this.set({
            singlePageOnly: true,
            viewMode: 'page',
            pdfOnly: false
        });

        o.disableDocMode && this.set({
            disableThumbs: true,
            viewMode: (this.viewMode() === 'document') ? 'page' : this.viewMode()
        });

        // Disallow fullTextQuickView if fullTextQuery is not provided as an option (use string to allow empty search search, if not provided will be undefined)
        (o.fullTextQuickView  && typeof o.fullTextQuery !== 'string') && this.set({
            fullTextQuickView: false
        });

        this.get('fullTextQuickView') && this.set({ //(builds off above)
            fullTextQuickView: true,
            autoDisplayIndexes: false,
            forceOpenToNotes: false
        });

        o.createNewRedactionOnEntry && this.set({
            viewMode: 'page',
            excludePageNotes: false,
            pdfOnly: false,
            forceOpenToNotes: true,
            fullTextQuickView: false
        });


        if ( o.findAndRedact ) {

            this.set({
                viewMode: 'page',
                excludePageNotes: false,
                autoDisplayIndexes: false,
                pdfOnly: false,
                fullTextQuickView: false
            });
        }


        //TODO: implement this -- not now due to breaking existing API(?)
        /*
         - singularViewMode (optional)
         - default: false
         - if true, hides entry points to enter view modes other than the given (or default) viewMode (still created for time being)
         - if viewMode is 'pdf', excludePageNotes set to true
         - fvs.singluarViewMode
         * */
    },


    /* returns array of err messages or empty array */
    checkOptionalParams: function() { 

        //TODO: ACTIVE DOC INDEX (?)...
        var aErrors = [],
            s = this.attributes;

        /* NOTE: THIS CHECKED AFTER SET -- IF NOT PROVIDED IS THAT OF FV BUT CAN BE SET TO AN INVALID ONE */
        if ( s.imageFileType && !_.contains( this.validImgFileTypes, s.imageFileType.toUpperCase() ) ) { 
            aErrors.push( s.imageFileType.toUpperCase() + ' is not a valid image file type.');
        }

        //leave room for more...
        return aErrors.join('x').replace('x', '<br>');  //put a linebreak in html format
    },

    hideIndexes: function() {
        return this.get('hideIndexes');
    },
    fullTextQuery: function() {
        return this.get('fullTextQuery');
    },
    fullTextQuickView: function() {
        return this.get('fullTextQuickView');
    },
    forceOpenToNotes: function() {
        return this.get('forceOpenToNotes');
    },
    autoDisplayIndexes: function() {
        return this.get('autoDisplayIndexes');
    },
    disableThumbs: function() {
        return this.get('disableThumbs');
    },
    excludePageNotes: function() {
        return this.get('excludePageNotes');
    },
    fullScreen: function() {
        return this.get('fullScreen');
    },
    viewMode: function() {
        return this.get('viewMode');
    },
    createNewRedactionOnEntry: function() {
        return this.get('createNewRedactionOnEntry');
    },
    el: function() { //translates to container (in channel)
        return this.get('el');
    },
    imageFileType: function() {
        return this.get('imageFileType');
    },
    docModeScale: function() {
        return this.get('docModeScale');
    },
    pageModeScale: function() {
        return this.get('pageModeScale');
    },
    hideActivityNotes: function() {
        return this.get('hideActivityNotes');
    },
    pdfOnly: function() {
        return this.get('pdfOnly');
    },
    singlePageOnly: function() {
        return this.get('singlePageOnly');
    },
    disableDocMode: function() {
        return this.get('disableDocMode');
    },
    openToPageNumber: function() {
        return this.get('openToPageNumber');
    },

    findAndRedact: function() {
      return this.get('findAndRedact');
    },

    getValidatedOpenToPageNumber: function(pgNum) {

        var defaultNum = this.defaults.openToPageNumber;

        //check undefined in case 0 provided
        if (pgNum === undefined)
            return defaultNum;

        //this is valid: once pages are known, it will be set to the last page number

        if (pgNum === 'last')
            return pgNum;

        if (Util.isIntegerGreaterThanZero(pgNum))
            return pgNum;

        return Util.isIntegerGreaterThanZero(pgNum) ? pgNum : defaultNum;
    }
});






/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/settings/settings.js
 ** module id = 99
 ** module chunks = 0
 **/